// app/auth/login/ChooseGroupPanel.js
import React from 'react';
import { Button, Typography } from '@material-ui/core';

export default function ChooseGroupPanel({ groups = [], onSelect, onRefresh, disabled }) {
    return (
        <div className="w-full mt-12">
            <Typography variant="subtitle1" className="w-full text-center mb-8 opacity-80 text-xs">Choose a group to continue</Typography>

            {Array.isArray(groups) && groups.length > 0 ? (
                <div className="flex flex-wrap gap-8">
                    {groups.map((g) => (
                        <Button className="flex-1" key={g.id ?? g.name} variant="contained" disabled={!!disabled} onClick={() => (onSelect ? onSelect(g) : console.log('[chooseGroup] select:', g))}>
                            {g.name ?? String(g.id)}
                        </Button>
                    ))}
                </div>
            ) : (
                <div className="flex flex-col items-center gap-12">
                    <Typography variant="body2" className="opacity-60 text-xs">No groups available yet.</Typography>
                    {/* <Button variant="text" disabled={!!disabled} onClick={() => (onRefresh ? onRefresh() : console.log('[chooseGroup] refresh'))}>Refresh</Button> */}
                </div>
            )}
        </div>
    );
}
